module.exports = __webpack_public_path__ + "img/shiba-loading.a8c36d7a.gif";